import React, { useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import './style/ScrollText.css';

gsap.registerPlugin(ScrollTrigger);

const ScrollTextEffect = ({ text, speed = 30, className = "" , letspeed, dletspeed}) => {
const textRef = useRef(null);
    const wrapperRef = useRef(null);
    const [isComplete, setIsComplete] = useState(false);

    useGSAP(() => {
        const element = textRef.current;
        const targetText = text;
        const letters = "!<>-_\\/[]{}—=+*^?#________0123456789";
        // إنشاء ScrollTrigger لتشغيل التأثير عندما يظهر العنصر في الشاشة
        ScrollTrigger.create({
            trigger: element,
            start: "top 50%",
            onEnter: () => {
                let iterations = 0;
                setIsComplete(false);
                
                const interval = setInterval(() => {
                    element.innerText = targetText
                        .split("")
                        .map((letter, index) => {
                            if (letter === " ") return " "; // الحفاظ على المسافات
                            
                            if (index < iterations) {
                                return targetText[index]; // إظهار الحرف الحقيقي
                            }
                            
                            // إظهار حرف عشوائي مشفر
                            return letters[Math.floor(Math.random() * letters.length)];
                        })
                        .join("");
                    
                    if (iterations >= targetText.length) {
                        clearInterval(interval);
                        setIsComplete(true); // إخفاء كيرسر الكتابة
                    }
                    
                    iterations += letspeed ? letspeed : 0; // سرعة الانتقال واستقرار الحروف
                }, speed);
            },
            // لو عايز الأنميشن يعيد نفسه لما العميل يطلع فوق وينزل تاني، فك الكومنت عن السطر اللي تحت:
            // toggleActions: "restart none none none"
        });
    }, { scope: wrapperRef, dependencies: [text] });
    const detletspeed = (e)=>{
        letspeed = e
    }
    return (
        <span onMouseEnter={()=>{detletspeed(dletspeed)}} ref={wrapperRef} className={`animated-text-wrapper ${isComplete ? 'typing-complete' : ''}`}>
            <span ref={textRef} className={`scramble-text ${className}`}>
                {/* يظهر فارغ أو بنص شفاف مؤقتاً حتى يبدأ الـ ScrollTrigger */}
            </span>
        </span>
    );
};

export default ScrollTextEffect;